"use client";
import { buttonVariants } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Facebook, Instagram, Linkedin, Twitter, Github } from "lucide-react";
import Link from "next/link";
import { useTranslation } from "@/hooks/useLanguage";

export const Team = () => {
  const { t } = useTranslation();
  const teamList = t("team.team_list");

  // Ensure teamList is always an array to prevent runtime errors
  const safeTeamList = Array.isArray(teamList) ? teamList : [];

  const socialIcon = (iconName) => {
    switch (iconName) {
      case "LinkedIn":
        return <Linkedin size="20" />;
      case "Facebook":
        return <Facebook size="20" />;
      case "Instagram":
        return <Instagram size="20" />;
      case "Twitter":
        return <Twitter size="20" />;
      case "GitHub":
        return <Github size="20" />;
      case "Dribbble":
        return <Github size="20" />;
      default:
        return null;
    }
  };

  return (
    <section id="team" className="container py-24 sm:py-32">
      <h2 className="text-3xl md:text-4xl font-bold">
        <span className="bg-gradient-to-b from-primary/60 to-primary text-transparent bg-clip-text">
          {t("team.title_1")}{" "}
        </span>
        {t("team.title_1_span")}
      </h2>

      <p className="mt-4 mb-10 text-xl text-muted-foreground">
        {t("team.description")}
      </p>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 gap-y-10">
        {safeTeamList.map(({ image, name, position, socialNetworks }) => (
          <Card
            key={name}
            className="bg-muted/50 relative mt-8 flex flex-col justify-center items-center"
          >
            <CardHeader className="mt-8 flex justify-center items-center pb-2">
              <img
                src={image}
                alt={`${name} ${position}`}
                className="absolute -top-12 rounded-full w-24 h-24 aspect-square object-cover"
              />
              <CardTitle className="text-center">{name}</CardTitle>
              <CardDescription className="text-primary">
                {position}
              </CardDescription>
            </CardHeader>

            <CardContent className="text-center pb-2">
              {t("team.description")}
            </CardContent>

            <CardFooter>
              {(Array.isArray(socialNetworks) ? socialNetworks : []).map(
                ({ name, url }) => (
                  <div key={name}>
                    <Link
                      rel="noreferrer noopener"
                      href={url}
                      target="_blank"
                      className={buttonVariants({
                        variant: "ghost",
                        size: "sm",
                      })}
                    >
                      <span className="sr-only">{name} icon</span>
                      {socialIcon(name)}
                    </Link>
                  </div>
                ),
              )}
            </CardFooter>
          </Card>
        ))}
      </div>
    </section>
  );
};
